import script from "./CancelAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelAccount.vue?vue&type=script&setup=true&lang=js"

import "./CancelAccount.vue?vue&type=style&index=0&id=52b2d3d5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b2d3d5"]])

export default __exports__